import { UUID } from "angular2-uuid";
import { StoredPiece } from "src/app/storage/models/stored-orders/stored-piece";

/**
 * An instance of the StoredPiece model to be used for schema validation
 */
export const storedPieceInstance: StoredPiece = {
	PieceId: new UUID(),
	Dimensions: {
		Weight: 0,
		Height: 0,
		Length: 0,
		Width: 0
	},
	DescriptionOfGoods: "",
	Hazmat: {
		IsPlacardRequired: false,
		UNNumber: "",
		Description: "",
		ClassNumber: "",
		PackageGroup: "",
		EmergencyPhoneNumber: ""
	},
	Quantity: 0,
	ReferenceNumber: ""
}